import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import CommonNav from "../main/CommonNav2";
import Footer from "../main/Footer";

import GBTSLogoSvg from "../assets/GBTSLogoSvg";

import BuddibleSocket, { MsgIDList } from "../lib/BuddibleSocket";
import Utilities from "../lib/Utilities";
import CodeList from "../lib/CodeList";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

const _mClassName = "PostMain";
const _urls = {
  notice: "/notice/JS_notice_select.php",
  carrierNotice: "/logistoryBoard/JS_postLogistorySelect.php",
  qna: "/qa/JS_qa_select.php",
  promotion: "/promotion/JS_promotion_select.php",
};

let rowsPerPage = 4;
let page = 0;
let sortModel = [];
let filters = {};
export default function PostMain() {
  const { t, i18n } = useTranslation();
  const [loginInfo, setLoginInfo] = useState(null);
  const [notice, setNotice] = useState([]);
  const [carrierNotice, setCarrierNotice] = useState([]);
  const [qna, setQna] = useState([]);
  const [promotion, setPromotion] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  /**/
  (() => {
    socket.addLocalEventListener(
      MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
      _mClassName,
      (b, n) => {
        if (n) {
          if (n["returnData"].length) {
            setLoginInfo({ ...n["returnData"][0] });
          }
        }
      }
    );
  })();

  useEffect(() => {
    i18n.changeLanguage(i18n.language, () => {});

    for (const key in _urls) {
      SELECT_POST_LIST(key, (response) => {
        if (key === "notice") {
          setNotice(response);
        } else if (key === "carrierNotice") {
          setCarrierNotice(response);
        } else if (key === "qna") {
          setQna(response);
        } else if (key === "promotion") {
          setPromotion(response);
        }
      });
    }

    let userdata = socket.getLocalDataSet(MsgIDList.EVENT_LOGIN_AUTO_SUCCESS);
    if (userdata) {
      if (userdata["returnData"].length) {
        setLoginInfo(userdata["returnData"][0]);
      }
    }
    return () => {
      socket.removeLocalEventListener(
        MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
        _mClassName
      );
    };
  }, []);

  function SELECT_POST_LIST(key, callback) {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: _urls[key],
      msgID: msgID,
      data: {},
      take: rowsPerPage,
      skip: page * rowsPerPage,
      page: page + 1,
      pageSize: 5,
      sort: [...sortModel],
      ...filters,
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          callback(newData["returnData"]);
        }
      }
    });
  }

  function requestInquiryViaLogiTalk() {
    codeList.Modal.current.confirm(t("post.msg.inquiryViaLogiTalk"), (ret) => {
      if (ret) {
        if (!loginInfo) {
          codeList.Modal.current.alert(t("commonMSG.requiresLogin"));
          return;
        }
        localStorage.setItem("enquiryManager", "Z0001|hskim@gbts.co.kr");
        window.open("/LogiTalk", "LogiTalk", "_blank");
      }
    });
  }

  return (
    <>
      <CommonNav />
      <main>
        <div
          className="position-relative"
          style={{
            minHeight: 720,
            height: "40vh",
            background:
              "url(/images/gbts_carousel_1.jpg) 50% 50%/ cover no-repeat",
          }}
        >
          <div
            className="w-100 h-100 d-flex flex-column justify-content-center align-items-center py-5 text-white text-center"
            style={{
              background:
                "linear-gradient(to bottom,rgba(19,22,56,0),rgba(19,22,56,0.6) ) ",
            }}
          >
            <div className="container text-left text-lg-center">
              <p className="h2 mb-3 font-weight-bold">{t("post.main.title")}</p>
              <p className="h5 mb-4 font-weight-normal">
                {t("post.main.description")}
              </p>

              <div className="row m-0 p-0">
                {["notice", "carrierNotice", "qna", "promotion"].map((key) => (
                  <Link
                    to={"/PostList/" + key}
                    key={key}
                    className="col-6 col-lg-3 m-0 p-1 cursor_pointer d-flex text-white"
                  >
                    <div className="w-100 p-3 bg-glass-4 rounded-lg border-white text-left cursor-pointer-bg-freiscop shadow d-flex flex-column justify-content-between">
                      <div>
                        <p className="h6 font-weight-bold">
                          {t(`post.main.${key}.title`)}
                        </p>
                        <p className="mb-2">{t(`post.main.${key}.desc`)}</p>
                      </div>
                      <div className="text-right">
                        <span>{t(`post.main.${key}.more`)} →</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>

              <div className="d-flex flex-row justify-content-end justify-content-lg-center mt-3">
                <Link
                  to="/WritePost"
                  className="btn btn-outline-light rounded-lg mr-1"
                >
                  {t("post.main.writeInquiry")}
                </Link>
                <button
                  className="btn btn-info rounded-lg ml-1"
                  onClick={requestInquiryViaLogiTalk}
                >
                  {t("post.main.logitalkInquiry")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="py-5">
          <section id="ship-comp-notice" className="container py-4 mb-4">
            <p className="h5 font-weight-bold text-freiscop mb-1">
              {t("post.main.carrierNotice.title")}{" "}
              <i className="fa-regular fa-file-lines" />
            </p>
            <p className="mb-2">{t("post.main.carrierNotice.desc")}</p>
            <Link
              to="/PostList/carrierNotice"
              className="cursor_pointer cursor_pointer_fw_bold text-dark"
            >
              {t("post.main.carrierNotice.more")}{" "}
              <i className="fa-solid fa-circle-arrow-right" />
            </Link>
            <div className="row m-0 mt-3 p-0">
              <div className="col-12 col-lg-7 m-0 p-0">
                {carrierNotice.map((data) => {
                  let hash = "";
                  for (let key in data) {
                    if (key.indexOf("IDX") > -1) {
                      hash = data[key];
                    }
                  }

                  let prLOGO;
                  if (data.prLOGO) {
                    prLOGO = data.prLOGO.split("?")[0];
                  }

                  return (
                    <div
                      key={data.prIDX}
                      className={`mb-2 p-3 rounded border border-light shadow-sm d-flex flex-row justify-content-between align-items-center cursor_pointer cursor_pointer_bg_light
                      ${
                        selectedPost && selectedPost.prIDX === data.prIDX
                          ? "bg-blue-light"
                          : ""
                      }
                      `}
                      onClick={() => setSelectedPost(data)}
                    >
                      <div
                        className="d-flex flex-row align-items-center"
                        style={{ width: "calc(100% - 80px)" }}
                      >
                        <div
                          className="d-inline-block mr-2 rounded-lg"
                          style={{
                            minWidth: 25,
                            width: 25,
                            height: 25,
                            background: `url(${prLOGO})50% 50%/contain rgb(250,250,250) no-repeat`,
                          }}
                        >
                          {!prLOGO && (
                            <div className="w-100 h-100 rounded bg-blue-light d-flex flex-row justify-content-center align-items-center">
                              <span>LOGO</span>
                            </div>
                          )}
                        </div>
                        <p className="mb-0 font-weight-bold text-truncate">
                          {data.prTITLE.trim()}
                        </p>
                      </div>
                      <p
                        className="text-right"
                        style={{ minWidth: 80, width: 80 }}
                      >
                        {data.prCreateDate.split(" ")[0]}
                      </p>
                    </div>
                  );
                })}
              </div>
              <div className="col-12 col-lg-5 m-0 p-0 pb-1 pl-lg-3">
                {!selectedPost && (
                  <div
                    className="h-100 rounded-lg overflow-hidden bg-light d-flex flex-row justify-content-center align-items-center"
                    style={{ minHeight: 200 }}
                  >
                    <GBTSLogoSvg />
                  </div>
                )}
                {selectedPost && (
                  <div className="p-3 rounded-lg border border-light shadow-sm">
                    <div style={{ height: 200 }} className="overflow-hidden">
                      <div className="d-flex flex-row justify-content-between align-items-center pb-1 mb-1 border-bottom">
                        <div className="d-flex flex-row align-items-center">
                          <div
                            className="mr-2 rounded-lg"
                            style={{
                              minWidth: 25,
                              width: 25,
                              height: 25,
                              background: `url(${selectedPost.prLOGO})50% 50%/contain rgb(250,250,250) no-repeat`,
                            }}
                          >
                            {!selectedPost.prLOGO && (
                              <div className="w-100 h-100 rounded bg-blue-light d-flex flex-row justify-content-center align-items-center">
                                <span>LOGO</span>
                              </div>
                            )}
                          </div>
                          <p
                            className="m-0 mr-2 font-weight-bold"
                            style={{ minWidth: 100 }}
                          >
                            {selectedPost.prBCOMPNM ||
                              t("main.shipCompNotice.compName")}
                          </p>
                        </div>
                        <p className="">
                          {selectedPost.prCreateDate.split(" ")[0]}
                        </p>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: selectedPost.prCONTENTS,
                        }}
                      />
                    </div>
                    <div className="text-right mt-2">
                      <Link
                        to={"/PostDetail/carrierNotice/" + selectedPost.prIDX}
                        className="cursor_pointer cursor_pointer_fw_bold text-dark"
                      >
                        {t("post.viewDetail")} →
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>

          <section className="container py-5">
            <div className="row m-0 p-0">
              <div className="col-12 col-lg-4 m-0 p-0 py-3">
                <p className="h5 font-weight-bold text-freiscop mb-1">
                  {t("post.main.notice.title")}{" "}
                  <i className="fa-regular fa-bell" />
                </p>
                <p className="mb-2">{t("post.main.notice.desc")}</p>
                <Link
                  to="/PostList/notice"
                  className="cursor_pointer cursor_pointer_fw_bold text-dark"
                >
                  {t("post.main.notice.more")}{" "}
                  <i className="fa-solid fa-circle-arrow-right" />
                </Link>
              </div>
              <div className="col-12 col-lg-8 m-0 p-0">
                <div className="row m-0 my-2 p-0">
                  {notice.map((data, index) => (
                    <NoticeItem key={data.ntIDX} data={data} index={index} />
                  ))}
                  {notice.length === 0 && (
                    <div className="col-12 m-0 p-5 text-center text-secondary bg-blue-light rounded-lg">
                      {t("commonMSG.noData")}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>

          <section className="container py-5">
            <div
              className="row m-0 p-5 rounded-lg"
              style={{
                background:
                  "linear-gradient(to right, rgba(0,32,96,0.7), rgba(0,32,96,1)) ",
              }}
            >
              <div className="col-0 col-lg-6 m-0 p-0"></div>
              <div className="col-12 col-lg-6 m-0 p-0 text-white">
                <p className="h4 font-weight-900">About GBTS</p>
                <p className="mb-1">{t("post.main.banner.description")}</p>
                <Link to="/Info" className="text-white">
                  {t("post.main.banner.more")}{" "}
                  <i className="fa-solid fa-circle-arrow-right" />
                </Link>
              </div>
            </div>
          </section>
          <section className="container py-5">
            <div className="row m-0 p-0">
              <div className="col-12 m-0 p-0 py-3">
                <p className="h5 font-weight-bold text-freiscop mb-1">
                  {t("post.main.qna.title")}{" "}
                  <i className="fa-regular fa-circle-question" />
                </p>
                <p className="mb-2">{t("post.main.qna.desc")}</p>
                <Link
                  to="/PostList/qna"
                  className="cursor_pointer cursor_pointer_fw_bold text-dark"
                >
                  {t("post.main.qna.more")}{" "}
                  <i className="fa-solid fa-circle-arrow-right" />
                </Link>
              </div>
              <div className="col-12 m-0 p-0">
                <div className="row m-0 my-2 p-0">
                  {qna.map((data, index) => (
                    <QnaItem key={data.qaIDX} data={data} index={index} />
                  ))}
                  {qna.length === 0 && (
                    <div className="col-12 m-0 p-5 text-center text-secondary bg-blue-light rounded-lg">
                      {t("commonMSG.noData")}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
          <section className="container py-5">
            <div className="row m-0 p-0">
              <div className="col-12 m-0 p-0 py-3">
                <p className="h5 font-weight-bold text-danger mb-1">
                  {t("post.main.promotion.title")}{" "}
                  <i className="fa-solid fa-gift" />
                </p>
                <p className="mb-2">{t("post.main.promotion.desc")}</p>
                <Link
                  to="/PostList/promotion"
                  className="cursor_pointer cursor_pointer_fw_bold text-dark"
                >
                  {t("post.main.promotion.more")}{" "}
                  <i className="fa-solid fa-circle-arrow-right" />
                </Link>
              </div>
              <div className="col-12 m-0 p-0">
                <div className="row m-0 my-2 p-0">
                  {promotion.map((data, index) => (
                    <PromotionItem key={data.prIDX} data={data} index={index} />
                  ))}
                  {promotion.length === 0 && (
                    <div className="col-12 m-0 p-5 text-center text-secondary bg-blue-light rounded-lg">
                      {t("commonMSG.noData")}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}

const PromotionItem = ({ data, index }) => {
  const { t } = useTranslation();
  return (
    <div className="col-6 col-lg-3 m-0 p-1 d-flex">
      <Link
        to={"/PostDetail/qna/" + data.prIDX}
        className="w-100 h-100 p-3 rounded-lg border bg-white shadow-sm text-dark cursor_pointer cursor_pointer_bg_light"
      >
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div>
            <p className="h6 mb-1 font-weight-bold">{data.prTITLE}</p>
            <p>{util.getDateToFormat(data.prCreateDate, "YYYY.MM.DD")}</p>
          </div>
          <div className="text-right">
            <span>{t("post.viewDetail")} →</span>
          </div>
        </div>
      </Link>
    </div>
  );
};

const QnaItem = ({ data, index }) => {
  const { t } = useTranslation();
  return (
    <div className="col-12 m-0 px-0 py-1 d-flex">
      <Link
        to={"/PostDetail/qna/" + data.qaIDX}
        className="w-100 h-100 p-3 rounded-lg border bg-white shadow-sm text-dark cursor_pointer cursor_pointer_bg_light"
      >
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div>
            <p className="h6 mb-1 font-weight-bold">{data.qaTITLE}</p>
            <p>{util.getDateToFormat(data.qaCreateDate, "YYYY.MM.DD")}</p>
          </div>
          <div className="text-right" style={{ minWidth: 80 }}>
            <span>{t("post.viewDetail")} →</span>
          </div>
        </div>
      </Link>
    </div>
  );
};

const NoticeItem = ({ data, index }) => {
  const { t } = useTranslation();
  return (
    <div className="col-6 m-0 p-1 d-flex">
      <Link
        to={"/PostDetail/notice/" + data.ntIDX}
        className={`w-100 h-100 p-3 rounded-lg shadow-sm d-flex flex-column justify-content-between cursor_pointer cursor-pointer-bg-freiscop ${
          index === 0 ? "bg-blue-light font-weight-bold" : ""
        }`}
        style={{
          minHeight: 150,
        }}
      >
        <div>
          <p className="h6 mb-1 font-weight-bold">{data.ntTITLE}</p>
          <p>{util.getDateToFormat(data.ntCreateDate, "YYYY.MM.DD")}</p>
        </div>
        <div className="text-right">
          <span>{t("post.viewDetail")} →</span>
        </div>
      </Link>
    </div>
  );
};
